import { isObject, isFunction } from 'lodash'
import ExpandIcon from '../feature/expanded'
import { createCellOption } from './cell-option'
import { createCellContentWrap } from './cell-content-wrap'
import { selectNodeContents, isTextSelected, tableCellFormatterResult } from '../../utils'


const CellOption = createCellOption()
const CellContentWrap = createCellContentWrap()
let selectCellId = ''
let removeHighlightCallback

function clearContextMenuHighlight() {
  if (removeHighlightCallback && typeof removeHighlightCallback === 'function') {
    removeHighlightCallback({ type: 'click' })
    removeHighlightCallback = ''
  }
}

function setRowCellSelectd(el, cellId) {
  try {
    let target = el
    while (target && target.tagName !== 'TD') {
      target = target.parentNode
    }
    if (target) {
      const className = 'row-cell-selectd'
      const removeHighlight = (e) => {
        const { type } = e || {}
        if (type === 'contextmenu' && cellId === selectCellId) return
        target.classList.remove(className)
        if (cellId === selectCellId) {
          selectCellId = ''
        }
        // fix:table2表格右键复制完聚焦输入框
        const selectionInfo = window.getSelection()
        if (selectionInfo.anchorNode && selectionInfo.anchorNode.className && !selectionInfo.anchorNode.className.includes('input')) {
          selectionInfo.removeAllRanges()
        }
        ['click', 'contextmenu'].forEach(eventName => document.removeEventListener(eventName, removeHighlight))
      }
      document.addEventListener('click', removeHighlight)
      // 延迟的目的是为了延迟冒泡，导致点击自身也清除了
      setTimeout(() => {
        document.addEventListener('contextmenu', removeHighlight)
      }, 100)
      if (!Array.from(target.classList).includes(className)) {
        target.classList.add(className)
      }
      return removeHighlight
    }
  } catch (e) {
    console.log(e)
  }
}


function renderPlaceholderSign (h, {tdStyle, colRowSpan}) {
  const { rowspan, colspan } = colRowSpan
  if (!rowspan || !colspan) return <td style="display: none"></td>
  const tdAttrs = {
    attrs: (colspan === 1 && rowspan === 1) ? null : {
      colspan,
      rowspan
    },
    style: tdStyle
  }
  return <td placeholderSign="true" {...tdAttrs}></td>
}

export function createCell() {
  return {
    functional: true,
    name: 'TableCell',
    render(h, context) {
      const {
        column,
        rowData,
        isSelected,
        rowIndex,
        renderDataIndex,
        columnIndex,
        rowSelectedChanged,
        getSelection,
        setRadioSelectedInRows,
        getRadioSelected,
        radioProps,
        depth,
        indentSize,
        expandIconProps,
        iconSize,
        expandColumnKey,
        expandedRowKeys,
        rowKey,
        selectable,
        isAllSelected,
        UPDATE_checkbox,
        fixedRowsTop,
        loading,
        handleEvent,
        cellClassName,
        cellStyle,
        _index,
        showSelection,
        showOverflowTooltip,
        rowHeight,
        headerAlign,
        tableDataLength,
        getColRowSpanResult,
        enableDynamicHeight,
        noWrap,
        currentSize,
        offsetY,
        scrollTop,
        tableBodyHeight,
        rowCellCanSelected,
        highlightCellsArea = {},
        isFooter, // 是否页脚
        isFixedRow, // 是否固定行
        mergeCellsScope
      } = context.props
      // 内容对齐方式的className
      const {
        placeholderSign,
        rowCellRender
      } = column
      // colspan rowspan
      const colRowSpan = {
        rowspan: 1,
        colspan: 1,
      }
      const cellId = rowIndex + '' + columnIndex

      // 合并的规则拿的是tableData的数据。页脚的规则不走这里
      const result = getColRowSpanResult && getColRowSpanResult(rowIndex, columnIndex)
      // 页脚页头共用合并规则
      const headerMerge = mergeCellsScope && mergeCellsScope['header'] && isFixedRow
      const bodyMerge = mergeCellsScope && mergeCellsScope['body'] && !isFixedRow && !isFooter
      const footerMerge = mergeCellsScope && mergeCellsScope['footer'] && isFooter

      if (bodyMerge || headerMerge || footerMerge) {
        if (typeof result === 'object') {
          colRowSpan.rowspan = result.rowspan
          colRowSpan.colspan = result.colspan
        }
      }

      const { rowspan, colspan } = colRowSpan
      const [$slots] = context.children
      let tdStyle = null
      if (columnIndex === 0) {
        if (enableDynamicHeight) {
          tdStyle = {
            height: currentSize + 'px'
          }
        }
      }
      // 超过可视区域部渲染空标签
      if (offsetY > 0 && ((tableBodyHeight + scrollTop - offsetY) < 0) && rowspan === 1) {
        return renderPlaceholderSign(h, {tdStyle, colRowSpan})
      }
      if (placeholderSign) return renderPlaceholderSign(h, {tdStyle, colRowSpan})

      const expandable = rowIndex >= 0 && expandColumnKey !== undefined && column.key === expandColumnKey

      let displayText = rowData[column.key]
      // 特写
      if (displayText === 'System') {
        displayText = '系统'
      }
      displayText = tableCellFormatterResult(context, {
        column,
        rowData,
        rowIndex,
        columnIndex,
        displayText
      })
      let IconOrPlaceholder = null
      // 树展开
      if (expandable) {
        const iconStyle = `margin-inline-start: ${depth * indentSize}px;`
        if (isObject(expandIconProps)) {
          const expanded = rowIndex >= 0 && expandedRowKeys.includes(rowData[rowKey])
          const _expandIconProps = {
            ...expandIconProps,
            iconStyle,
            expanded,
            loading,
            onExpand: (expanded) => {
              expandIconProps.onExpand({
                expanded,
                rowIndex,
                rowData,
                rowKey
              })
            },
            treeTableIcon: column.treeTableIcon
          }
          IconOrPlaceholder = <ExpandIcon {...{props: _expandIconProps}}></ExpandIcon>
        } else {
          IconOrPlaceholder = (
            <div
              style={[
                iconStyle,
                `width: ${iconSize}px; height: ${iconSize}px;display: inline-flex`,
              ].join(' ')}
            />
          )
        }
      }

      if (!rowspan || !colspan) return <td style="display: none"></td>
      const renderInnerCell = () => {
        const cellParams = {
          rowData,
          column,
          isSelected,
          rowIndex,
          columnIndex,
          rowSelectedChanged,
          getSelection,
          setRadioSelectedInRows,
          getRadioSelected,
          radioProps,
          selectable,
          isAllSelected,
          UPDATE_checkbox,
          rowKey,
          fixedRowsTop,
          _index,
          showSelection,
          value: displayText,
          showOverflowTooltip,
          IconOrPlaceholder,
          handleEvent,
          depth,
          isFooter,
          isFixedRow
        }
        if (rowCellRender) {
          return rowCellRender(h, cellParams, context)
        } else if ($slots.cell) {
          return isFunction($slots.cell) ? $slots.cell(cellParams) : $slots.cell
        } else {
          return <CellOption
            value={displayText}
            enableDynamicHeight={enableDynamicHeight}
            rowData={rowData}
            column={column}
            headerAlign={headerAlign}
            showOverflowTooltip={showOverflowTooltip}
            columnIndex={columnIndex}
            rowspan={rowspan}
            rowHeight={rowHeight}
            handleEvent={handleEvent}
            noWrap={noWrap}
            rowIndex={rowIndex}
          >
            {IconOrPlaceholder}
          </CellOption>
        }
      }
      const Cell = renderInnerCell()
      const areaClass = highlightCellsArea[rowIndex + '_' + columnIndex] ? 'highlight kye-copy-area' : ''
      const tdAttrs = {
        attrs: (colspan === 1 && rowspan === 1) ? null : {
          colspan,
          rowspan
        },
        style: {...tdStyle},
        class: [areaClass],
        on: {
          contextmenu: (event) => {
            // 有系统选择走默认
            if (isTextSelected()) return
            if (cellId !== selectCellId) {
              selectCellId = cellId
              event.preventDefault()
            }
            selectNodeContents(event.target)
            removeHighlightCallback = setRowCellSelectd(event.target, cellId)
          }
        }
      }
      clearContextMenuHighlight()
      return (
        <td
          {...tdAttrs}
          data-columnIndex={columnIndex}
          data-rowIndex={rowIndex}
          data-cellKey={column.key}
        >
          <CellContentWrap
            handleEvent={handleEvent}
            rowData={rowData}
            rowIndex={rowIndex}
            columnIndex={columnIndex}
            renderDataIndex={renderDataIndex}
            column={column}
            value={displayText}
            cellClassName={cellClassName}
            cellStyle={cellStyle}
            rowHeight={rowHeight}
            colspan={colspan}
            rowspan={rowspan}
            tableDataLength={tableDataLength}
            currentSize={currentSize}
            enableDynamicHeight={enableDynamicHeight}
            headerAlign={headerAlign}
            rowCellCanSelected={rowCellCanSelected}
            isFooter={isFooter}
          >
            {
              Cell
            }
          </CellContentWrap>
        </td>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/body/cell.js